"use client";

import { PLASMIC, PlasmicRootProvider } from "@stadium/services/plasmic";

// Import registrations as a side effect — this ensures components are
// registered in the PLASMIC loader instance. The actual registration code
// lives in plasmic-register.js (without "use client") so it can also be
// imported by server components for SSR query pre-fetching.
import "@client/plasmic-register";

/**
 * PlasmicClientRootProvider is a Client Component that passes in the loader for you.
 *
 * Why? Props passed from Server to Client Components must be serializable.
 * https://beta.nextjs.org/docs/rendering/server-and-client-components#passing-props-from-server-to-client-components-serialization
 * However, PlasmicRootProvider requires a loader, but the loader is NOT serializable.
 */
export function PlasmicClientRootProvider(
  props: Omit<React.ComponentProps<typeof PlasmicRootProvider>, "loader">,
) {
  return <PlasmicRootProvider loader={PLASMIC} {...props}></PlasmicRootProvider>;
}
